import React from "react";
import { spring, useCurrentFrame, useVideoConfig, interpolate } from "remotion";

interface OutroProps {
  keywords: string[];
  frame: number;
  fps: number;
}

export const SpatialThreeOutro: React.FC<OutroProps> = ({
  keywords,
  frame,
  fps,
}) => {
  const pulseScale = 1.0 + Math.sin((frame / fps) * Math.PI * 1.5) * 0.04;
  const buttonGlow = 15 + Math.sin((frame / fps) * Math.PI * 1.5) * 10;

  return (
    <div
      className="glass-panel glow-border-purple"
      style={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        textAlign: "center",
        boxShadow: `0 0 25px rgba(157, 78, 221, 0.25), var(--glass-shadow)`,
        padding: "50px 40px",
      }}
    >
      {/* Outro Badge */}
      <div className="badge badge-purple">
        {keywords?.[1] || "STAY SHARP"}
      </div>

      {/* Catchy dynamic outro hook line */}
      <h2
        style={{
          fontFamily: "var(--font-title)",
          fontSize: "56px",
          fontWeight: 900,
          lineHeight: 1.2,
          color: "#ffffff",
          marginBottom: "35px",
          background:
            "linear-gradient(135deg, #ffffff 40%, var(--accent-purple) 90%, #ffffff 100%)",
          WebkitBackgroundClip: "text",
          WebkitTextFillColor: "transparent",
          backgroundClip: "text",
        }}
      >
        Never Miss A Tech Shock
      </h2>

      {/* Pulsing CTA Action Button */}
      <div
        style={{
          transform: `scale(${pulseScale})`,
          transition: "transform 0.1s ease",
          cursor: "pointer",
          width: "80%",
          maxWidth: "350px",
          background:
            "linear-gradient(90deg, var(--accent-purple), var(--accent-pink))",
          borderRadius: "50px",
          padding: "20px 0",
          boxShadow: `0 0 ${buttonGlow}px rgba(157, 78, 221, 0.6)`,
          marginBottom: "40px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <span
          style={{
            fontFamily: "var(--font-title)",
            fontWeight: 800,
            fontSize: "26px",
            color: "#ffffff",
            textTransform: "uppercase",
            letterSpacing: "3px",
          }}
        >
          👉 Hit Follow 👈
        </span>
      </div>

      {/* Social Handle */}
      <div
        style={{
          fontFamily: "var(--font-title)",
          fontSize: "26px",
          fontWeight: 700,
          color: "var(--accent-cyan)",
          letterSpacing: "1px",
          display: "flex",
          alignItems: "center",
          gap: "10px",
        }}
      >
        <span style={{ fontSize: "28px" }}>🔔</span> @TheDigitalBullet
      </div>
    </div>
  );
};

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
